import React from 'react';
import {
  Card,
  Tabs,
  Spin,
  Row,
  Col,
  Alert
} from 'antd';
import {hashHistory} from 'react-router'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import StationToolbar from '../components/StationToolbar'
import StationCardEvent from '../components/StationCardEvent'
import StationCardCamera from '../components/StationCardCamera'
import StationCardDevice from '../components/StationCardDevice'
import ModalDeviceRelay from '../components/ModalDeviceRelay'
import ModalDeviceAIN from '../components/ModalDeviceAIN'
import ModalDeviceDIN from '../components/ModalDeviceDIN'
import {fetchStationPresentation, postDeviceCommand, postReboot, postSyncReq} from '../actions/station'
import {fetchCameras} from '../actions/camera'
import {fetchChartDeviceData, fetchTimeLineDeviceData, fetchChartPowerMeterDayData, fetchChartPowerMeterMonthData} from '../actions/chart'
import {subcribeTopic, unsubcribeTopic} from '../actions/mqtt'
import {timeConverterSimple, getDateConverterSimple} from '../utils'

import {
  CHANNEL_STATION_CONNECTION_STATUS,
  CHANELL_NEW_STATUS,
  CHANNEL_EVENT_BOTH,
  CHANNEL_NEW_CONFIG,
  SUB_CATEGORY_POWER_METER_DAY,
  SUB_CATEGORY_POWER_METER_MONTH,
  roleAdmin
} from '../constants/defaultValues'

const TabPane = Tabs.TabPane;

class StationPresentation extends React.Component {
  state = {
    visibleModalDeviceRelay: false,
    visibleModalDeviceAIN: false,
    visibleModalDeviceDIN: false,
    titleModalDevice: '',
    currentDevice: {}
  }

  componentWillMount() {
    this.props.dispatch(fetchStationPresentation())
  }

  componentDidMount() {
    const {currentSystem, currentStation} = this.props
    const systemID = currentSystem.ID
    const stationID = currentStation.ID
    const topics = [`${CHANNEL_STATION_CONNECTION_STATUS}/${systemID}/${stationID}`, `${CHANELL_NEW_STATUS}/${currentSystem.ID}/${currentStation.ID}`, `${CHANNEL_EVENT_BOTH}/${systemID}/${stationID}`, `${CHANNEL_NEW_CONFIG}/${systemID}/${stationID}`]
    this.props.dispatch(subcribeTopic(topics))
    this.props.dispatch(fetchCameras())
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.devices) {
      const {currentDevice} = this.state
      const device = nextProps.devices.find((dev) => {
        return dev.DeviceId === currentDevice.DeviceId
      });
      if (device) {
        this.setState({currentDevice: device})
      }
    }
  }

  componentWillUnmount() {
    const {currentSystem, currentStation} = this.props
    const systemID = currentSystem.ID
    const stationID = currentStation.ID
    const topics = [`${CHANNEL_STATION_CONNECTION_STATUS}/${systemID}/${stationID}`, `${CHANELL_NEW_STATUS}/${currentSystem.ID}/${currentStation.ID}`, `${CHANNEL_EVENT_BOTH}/${systemID}/${stationID}`, `${CHANNEL_NEW_CONFIG}/${systemID}/${stationID}`]
    this.props.dispatch(unsubcribeTopic(topics))
  }

  handleDeviceRelayClick(dev) {
    this.setState({visibleModalDeviceRelay: true, titleModalDevice: dev.Name, currentDevice: dev});
  }

  handleDeviceAINClick(dev) {
    this.setState({visibleModalDeviceAIN: true, titleModalDevice: dev.Name, currentDevice: dev});
  }

  handleDeviceDINClick(dev) {
    this.setState({visibleModalDeviceDIN: true, titleModalDevice: dev.Name, currentDevice: dev});
  }

  handleCancelModalDeviceRelay() {
    this.setState({visibleModalDeviceRelay: false});
  }

  handleCancelModalDeviceAIN() {
    this.setState({visibleModalDeviceAIN: false});
  }

  handleCancelModalDeviceDIN() {
    this.setState({visibleModalDeviceDIN: false});
  }

  handleCmd(devId, cmd) {
    const data = btoa(JSON.stringify({
      DeviceId: devId,
      Delay: 0,
      CommandValue: cmd,
      Duration: 0,
      NextValue: 0,
      RepeatCycle: 0,
      RepeatCount: 0
    }));
    const station = this.props.currentStation
    const command = {
      StationID: station.ID,
      CategoryID: devId,
      Data: data
    }
    this.props.dispatch(postDeviceCommand(command))
  }

  handleReboot() {
    const station = this.props.currentStation
    const reboot = {
      StationID: station.ID,
      HardwareID: station.HardwareID
    }
    this.props.dispatch(postReboot(reboot))
  }

  handleSyncReq() {
    const station = this.props.currentStation
    const sync = {
      StationID: station.ID,
      HardwareID: station.HardwareID
    }
    this.props.dispatch(postSyncReq(sync))
  }

  handleLineChartClick(dev) {
    const {currentStation} = this.props
    const linkTo = `station/${currentStation.ID}/datas`;
    const crrTimeUnix = new Date().getTime() / 1000;
    const from = getDateConverterSimple(new Date().getTime() / 1000)
    const to = getDateConverterSimple(new Date().getTime() / 1000)
    if (dev.SubCategory === SUB_CATEGORY_POWER_METER_DAY) {
      const weekFrom = getDateConverterSimple(crrTimeUnix - (7 * 24 * 60 * 60))
      const weekTo = getDateConverterSimple(crrTimeUnix)
      this.props.dispatch(fetchChartPowerMeterDayData(dev, 'week', weekFrom + " 00:00:00", weekTo + " 23:59:59", 0, -1))
    } else if (dev.SubCategory === SUB_CATEGORY_POWER_METER_MONTH) {
      const yearFrom = getDateConverterSimple(crrTimeUnix - (365 * 24 * 60 * 60))
      const yearTo = getDateConverterSimple(crrTimeUnix)
      this.props.dispatch(fetchChartPowerMeterMonthData(dev, 'year', yearFrom + " 00:00:00", yearTo + " 23:59:59", 0, -1))
    } else {
      this.props.dispatch(fetchChartDeviceData(dev, 'day', from + " 00:00:00", to + " 23:59:58", 0, -1))
    }

    hashHistory.push(linkTo)
  }

  handleTimeLineClick(dev) {
    const {currentStation} = this.props

    const linkTo = `station/${currentStation.ID}/datas`;
    const from = getDateConverterSimple(new Date().getTime() / 1000)
    const to = getDateConverterSimple(new Date().getTime() / 1000)
    this.props.dispatch(fetchTimeLineDeviceData(dev, 'day', from + " 00:00:00", to + " 23:59:58", 0, 20000))
    hashHistory.push(linkTo)
  }

  render() {
    const {
      currentSystem,
      currentStation,
      currentUser,
      rooms,
      devices,
      scripts,
      events,
      fetchingDevices,
      fetchingRecentEvent,
      receiving,
      sending,
      error,
      cameras,
      clientHeight,
      isMobile,
      location
    } = this.props
    const bodyStyle = {
      height: clientHeight
    }
    const tabContentStyle = {
      height: clientHeight,
      backgroundColor: '#fff',
      overflow: 'auto'
    }
    const breadcrumbs = [
      {
        Name: "Giám sát",
        Link: `/${currentSystem.ID}/presentation`
      }, {
        Name: currentStation.Name,
        Link: ""
      }
    ]

    const showCameraCard = cameras.length > 0
      ? true
      : false
    const showEventsCard = events.length > 0
      ? true
      : false
    const factorDeviceCol = (showCameraCard && showEventsCard)
      ? 1
      : (!showCameraCard && !showEventsCard)
        ? 3
        : 2
    const showAction = roleAdmin(currentUser.role)
      ? true
      : false

    const elDevices = !fetchingDevices
      ? <StationCardDevice rooms={rooms} devices={devices} error={error} height={clientHeight} small={showCameraCard} onRelayClick={(dev) => this.handleDeviceRelayClick(dev)} onAINClick={(dev) => this.handleDeviceAINClick(dev)} onDINClick={(dev) => this.handleDeviceDINClick(dev)}/>
      : <span className="center"><Spin/></span>
    const elEvents = !fetchingRecentEvent
      ? <StationCardEvent scripts={scripts} receiving={receiving} events={events}/>
      : <span className="center"><Spin/></span>
    return (<div>
      <StationToolbar location={location} breadcrumbs={breadcrumbs} station={currentStation} devices={devices} rooms={rooms} showAction={showAction} onReboot={() => this.handleReboot()} onSyncReq={() => this.handleSyncReq()}/> {
        currentStation.OnlineState === 0
          ? <Alert message={`Trạm mất kết nối tới server lúc: ${timeConverterSimple(currentStation.OnlineTime)}`} type="error" closable="closable"/>
          : null
      }{
        isMobile
          ? <Tabs tabPosition="bottom" size="small">
              {
                showCameraCard
                  ? <TabPane tab="Camera" key="1" style={tabContentStyle}><StationCardCamera cameras={cameras} system={currentSystem}/></TabPane>
                  : null
              }
              <TabPane tab="Sự kiện" key="2" style={tabContentStyle}><StationCardEvent scripts={scripts} receiving={receiving} events={events}/></TabPane>
              <TabPane tab="Thiết bị" key="3" style={tabContentStyle}><StationCardDevice rooms={rooms} devices={devices} error={error} height={clientHeight} onRelayClick={(dev) => this.handleDeviceRelayClick(dev)} onAINClick={(dev) => this.handleDeviceAINClick(dev)} onDINClick={(dev) => this.handleDeviceDINClick(dev)}/></TabPane>
            </Tabs>
          : <Row align="middle">
              {
                showCameraCard
                  ? <Col xs={{
                        span: 24
                      }} sm={{
                        span: 24
                      }} md={{
                        span: 12
                      }} lg={{
                        span: 8
                      }} xl={{
                        span: 8
                      }}>
                      <Card title="Camera" className="card" bodyStyle={bodyStyle} hoverable={true}><StationCardCamera cameras={cameras} system={currentSystem}/></Card>
                    </Col>
                  : null
              }{
                showEventsCard
                  ? <Col xs={{
                        span: 24
                      }} sm={{
                        span: 24
                      }} md={{
                        span: 12
                      }} lg={{
                        span: 8
                      }} xl={{
                        span: 8
                      }}>
                      <Card title="Sự kiện" className="card" bodyStyle={bodyStyle} hoverable={false}>{elEvents}</Card>
                    </Col>
                  : null
              }
              <Col xs={{
                  span: 24
                }} sm={{
                  span: 24
                }} md={{
                  span: 12
                }} lg={{
                  span: 8 * factorDeviceCol
                }} xl={{
                  span: 8 * factorDeviceCol
                }}>
                <Card title="Thiết bị" className="card" bodyStyle={bodyStyle} hoverable={false}>{elDevices}</Card>
              </Col>
            </Row>
      }
      <ModalDeviceRelay visible={this.state.visibleModalDeviceRelay} title={this.state.titleModalDevice} device={this.state.currentDevice} sending={sending} onTimeLineClick={(dev) => this.handleTimeLineClick(dev)} onCmd={(devId, cmd) => this.handleCmd(devId, cmd)} onCancel={() => this.handleCancelModalDeviceRelay()}/>
      <ModalDeviceAIN visible={this.state.visibleModalDeviceAIN} title={this.state.titleModalDevice} device={this.state.currentDevice} sending={sending} onLineChartClick={(dev) => this.handleLineChartClick(dev)} onCancel={() => this.handleCancelModalDeviceAIN()}/>
      <ModalDeviceDIN visible={this.state.visibleModalDeviceDIN} title={this.state.titleModalDevice} device={this.state.currentDevice} sending={sending} onTimeLineClick={(dev) => this.handleTimeLineClick(dev)} onCancel={() => this.handleCancelModalDeviceDIN()}/>
    </div>);
  }
}
StationPresentation.propTypes = {
  dispatch: PropTypes.func,
  mqttConnected: PropTypes.bool,
  currentSystem: PropTypes.object,
  currentStation: PropTypes.object,
  currentUser: PropTypes.object,
  cameras: PropTypes.array,
  devices: PropTypes.array,
  rooms: PropTypes.array,
  scripts: PropTypes.array,
  events: PropTypes.array,
  receiving: PropTypes.bool,
  fetchingDevices: PropTypes.bool,
  fetchingRecentEvent: PropTypes.bool,
  sending: PropTypes.bool,
  error: PropTypes.string
}

const mapStateToProps = function(state) {
  return {
    mqttConnected: state.mqtt.connected,
    currentSystem: state.system.currentSystem,
    currentStation: state.station.currentStation,
    currentUser: state.user.currentUser,
    cameras: state.camera.cameras,
    rooms: state.device.rooms,
    devices: state.device.devices,
    scripts: state.device.scripts,
    events: state.device.events,
    receiving: state.device.receivingNewEvents,
    fetchingDevices: state.device.fetchingDevices,
    fetchingRecentEvent: state.device.fetchingRecentEvent,
    sending: state.device.sendingDeviceCommand,
    error: state.device.error
  }
}

export default connect(mapStateToProps)(StationPresentation)



// WEBPACK FOOTER //
// ./src/pages/StationPresentation.js